// // import React, { useState } from "react";

// // import BookingCard from "src/components/Booking/BookingCard";

// // import BookingDetailsModal from "src/components/Booking/BookingDetailsModal";

// // import ReviewModal from "src/components/Booking/ReviewModal";

// // import { getProposals } from "../api/proposal";

// // import { mapProposalToBooking } from "../utils/bookingUtils";

// // const MyBooking = () => {

// //   // Updated tabs as per requirement

// //   const button = ["Active Requests", "Booked Events", "Archived Events"];

// //   const [activeTab, setActiveTab] = useState(button[0]);

// //   const [selectedBooking, setSelectedBooking] = useState(null);

// //   const [showDetailsModal, setShowDetailsModal] = useState(false);

// //   const [showReviewModal, setShowReviewModal] = useState(false);

// //   // Dynamic state for Booked Events

// //   const [bookedEvents, setBookedEvents] = useState([]);

// //   const [loading, setLoading] = useState(false);

// //   const bookingsData = [

// //     {

// //       id: 1,

// //       category: "Events",

// //       heading: "Anshu 25th Birthday",

// //       purpose: "Birthday",

// //       date: "12/12/22",

// //       pax: 200,

// //       venue: "Lucknow",

// //       description: "A grand 25th birthday celebration with live music, gourmet catering, and custom decorations.",

// //       bookingDate: "10/11/22",

// //       status: "Completed",

// //       amount: 85000,

// //       paymentStatus: "Paid",

// //       contactPerson: "Rahul Sharma",

// //       contactPhone: "+91 98765 43210",

// //       contactEmail: "rahul.sharma@email.com",

// //       venueAddress: "The Grand Ballroom, Hazratganj, Lucknow, Uttar Pradesh 226001",

// //       timeSlot: "7:00 PM - 12:00 AM",

// //       services: [

// //         "DJ & Sound System",

// //         "Photography & Videography",

// //         "Catering (Veg & Non-veg)",

// //         "Stage Decoration",

// //         "LED Wall",

// //         "Valet Parking"

// //       ],

// //       specialRequests: "Chocolate fountain, customized cake with photo print",

// //       advancePayment: 25000,

// //       remainingPayment: 0,

// //       reviews: {

// //         rating: 4.5,

// //         comment: "Amazing celebration! The arrangements were perfect."

// //       }

// //     },

// //     {

// //       id: 2,

// //       category: "Events",

// //       heading: "Rohit & Neha Wedding",

// //       purpose: "Wedding",

// //       date: "18/01/23",

// //       pax: 350,

// //       venue: "Delhi",

// //       description: "Traditional Indian wedding with multiple ceremonies including Mehendi, Sangeet, and Reception.",

// //       bookingDate: "15/10/22",

// //       status: "Completed",

// //       amount: 450000,

// //       paymentStatus: "Paid",

// //       contactPerson: "Neha Kapoor",

// //       contactPhone: "+91 98123 45678",

// //       contactEmail: "neha.kapoor@email.com",

// //       venueAddress: "Imperial Palace, Rajouri Garden, New Delhi 110027",

// //       timeSlot: "Multi-day event (16-18 Jan)",

// //       services: [

// //         "Complete Wedding Planning",

// //         "Bridal Makeup",

// //         "Groom's Attire",

// //         "Photography & Videography",

// //         "Catering (1000+ dishes)",

// //         "Mandap Decoration",

// //         "Guest Accommodation",

// //         "Transportation"

// //       ],

// //       specialRequests: "Fireworks display, live band for Sangeet night",

// //       advancePayment: 150000,

// //       remainingPayment: 0,

// //       reviews: {

// //         rating: 5,

// //         comment: "Dream wedding came true! Every detail was perfect."

// //       }

// //     },

// //     {

// //       id: 3,

// //       category: "Packages",

// //       heading: "Premium Wedding Package",

// //       purpose: "Wedding",

// //       date: "05/02/23",

// //       pax: 400,

// //       venue: "Jaipur",

// //       description: "Luxury wedding package with royal Rajasthani theme, including heritage venue and traditional performers.",

// //       bookingDate: "20/11/22",

// //       status: "Completed",

// //       amount: 550000,

// //       paymentStatus: "Paid",

// //       contactPerson: "Vikram Singh",

// //       contactPhone: "+91 97654 32109",

// //       contactEmail: "vikram.singh@email.com",

// //       venueAddress: "Rajwada Palace Hotel, C-Scheme, Jaipur, Rajasthan 302001",

// //       timeSlot: "Multi-day event (3-5 Feb)",

// //       services: [

// //         "Heritage Venue Booking",

// //         "Royal Elephant Entry",

// //         "Folk Dancers & Musicians",

// //         "Complete Catering",

// //         "Professional Photography",

// //         "Destination Management",

// //         "Guest Welcome Kits",

// //         "Henna Artists"

// //       ],

// //       specialRequests: "Rajasthani folk music band, puppet show for guests",

// //       advancePayment: 200000,

// //       remainingPayment: 0,

// //       reviews: null

// //     },

// //     {

// //       id: 4,

// //       category: "Freelancers / Crew",

// //       heading: "DJ Night Event",

// //       purpose: "Music",

// //       date: "22/02/23",

// //       pax: 150,

// //       venue: "Mumbai",

// //       description: "High-energy DJ night with professional sound system and lighting setup.",

// //       bookingDate: "05/02/23",

// //       status: "Completed",

// //       amount: 35000,

// //       paymentStatus: "Paid",

// //       contactPerson: "DJ Rohan",

// //       contactPhone: "+91 99887 76655",

// //       contactEmail: "djrohan@email.com",

// //       venueAddress: "Skylounge Club, Andheri West, Mumbai, Maharashtra 400053",

// //       timeSlot: "9:00 PM - 2:00 AM",

// //       services: [

// //         "Professional DJ",

// //         "Sound System (10kW)",

// //         "LED Lighting",

// //         "Smoke Machine",

// //         "Laser Lights"

// //       ],

// //       specialRequests: "Bollywood + EDM mix playlist",

// //       advancePayment: 10000,

// //       remainingPayment: 0,

// //       reviews: {

// //         rating: 4,

// //         comment: "Great energy! The crowd loved it."

// //       }

// //     },

// //     {

// //       id: 5,

// //       category: "Events",

// //       heading: "Corporate Annual Meet",

// //       purpose: "Corporate",

// //       date: "10/03/23",

// //       pax: 500,

// //       venue: "Bangalore",

// //       description: "Annual corporate conference with keynote speakers, team building activities, and gala dinner.",

// //       bookingDate: "15/01/23",

// //       status: "Completed",

// //       amount: 320000,

// //       paymentStatus: "Paid",

// //       contactPerson: "Priya Desai",

// //       contactPhone: "+91 98765 11223",

// //       contactEmail: "priya.desai@company.com",

// //       venueAddress: "Tech Convention Center, Whitefield, Bangalore, Karnataka 560066",

// //       timeSlot: "9:00 AM - 10:00 PM",

// //       services: [

// //         "Conference Hall Setup",

// //         "AV Equipment",

// //         "Stage Setup",

// //         "Registration Desk",

// //         "Lunch & Dinner Catering",

// //         "Tea/Coffee Breaks",

// //         "Branded Materials"

// //       ],

// //       specialRequests: "Video conferencing for remote attendees, award ceremony setup",

// //       advancePayment: 100000,

// //       remainingPayment: 0,

// //       reviews: {

// //         rating: 4.5,

// //         comment: "Professionally organized. Our team was impressed."

// //       }

// //     }

// //   ];

// //   // Fetch dynamic booked events

// //   React.useEffect(() => {

// //     const fetchBookings = async () => {

// //       if (activeTab === "Booked Events") {

// //         setLoading(true);

// //         try {

// //           // Retrieve token from localStorage if context not available immediately

// //           const token = localStorage.getItem("token");

// //           if (!token) return;

// //           const proposals = await getProposals(token); // This fetches user's received proposals (if customer)

// //           // Filter for accepted/paid proposals

// //           // Note: Backend doesn't have explicit paymentStatus, so we rely on status === 'accepted' as proxy for Booked

// //           const confirmed = proposals

// //             .filter(p => p.status === 'accepted')

// //             .map(p => mapProposalToBooking(p));

// //           setBookedEvents(confirmed);

// //         } catch (error) {

// //           console.error("Failed to fetch booked events:", error);

// //         } finally {

// //           setLoading(false);

// //         }

// //       }

// //     };

// //     fetchBookings();

// //   }, [activeTab]);

// //   // Logic to determine which data to show

// //   // Active Requests -> Show static data (legacy behavior preserved)

// //   // Booked Events -> Show dynamic fetched data

// //   // Archived Events -> Show empty or static archived (placeholder)

// //   const getDisplayData = () => {

// //     if (activeTab === "Booked Events") return bookedEvents;

// //     if (activeTab === "Active Requests") return bookingsData; // Treating all static as active for now

// //     return []; // Archived empty for now

// //   };

// //   const filteredBookings = getDisplayData();

// //   const handleViewDetails = (booking) => {

// //     setSelectedBooking(booking);

// //     setShowDetailsModal(true);

// //   };

// //   const handleWriteReview = (booking) => {

// //     setSelectedBooking(booking);

// //     setShowReviewModal(true);

// //   };

// //   const handleCloseModals = () => {

// //     setShowDetailsModal(false);

// //     setShowReviewModal(false);

// //     // Small delay before clearing selected booking to allow modal animation

// //     setTimeout(() => setSelectedBooking(null), 300);

// //   };

// //   const handleSubmitReview = (reviewData) => {

// //     console.log("Review submitted:", reviewData);

// //     // Here you would typically send the review data to your backend

// //     alert("Thank you for your review! It has been submitted successfully.");

// //     handleCloseModals();

// //   };

// //   return (

// //     <div className="min-h-screen bg-white">

// //       {/* Header - Fixed with proper spacing */}

// //       <div className="fixed top-0 left-0 right-0 z-20 bg-white shadow-sm">

// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4">

// //           <div className="flex items-center justify-between">

// //             <div className="flex items-center gap-4 sm:gap-6">

// //               <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-orange-500 flex items-center justify-center text-white font-bold text-lg sm:text-xl">

// //                 G

// //               </div>

// //               <span className="text-sm sm:text-base font-medium text-gray-700">

// //                 Explore

// //               </span>

// //             </div>

// //             <div className="flex items-center gap-2 sm:gap-3">

// //               <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gray-300" />

// //               <div className="text-xs sm:text-sm leading-tight">

// //                 <p className="font-medium">Anshu Pandey</p>

// //                 <p className="text-xs text-gray-500">Event Host</p>

// //               </div>

// //             </div>

// //           </div>

// //         </div>

// //       </div>

// //       {/* Main Content - Added padding top for fixed header */}

// //       <div className="pt-16 sm:pt-20">

// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">

// //           {/* Title */}

// //           <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold mb-4 sm:mb-6">

// //             My booking

// //           </h1>

// //           {/* Tabs - Scrollable on small screens */}

// //           <div className="mb-6 sm:mb-8 overflow-x-auto">

// //             <div className="flex gap-4 sm:gap-6 min-w-max sm:min-w-0">

// //               {button.map((btn, index) => (

// //                 <button

// //                   key={index}

// //                   className={`pb-2 text-xs sm:text-sm whitespace-nowrap transition-all ${activeTab === btn

// //                     ? "border-b-2 border-orange-500 font-medium text-black"

// //                     : "text-gray-500 hover:text-gray-700"

// //                     }`}

// //                   onClick={() => setActiveTab(btn)}

// //                 >

// //                   {btn}

// //                 </button>

// //               ))}

// //             </div>

// //           </div>

// //           {/* Cards grid - Fully responsive */}

// //           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5 lg:gap-6">

// //             {filteredBookings.map((booking) => (

// //               <BookingCard

// //                 key={booking.id}

// //                 booking={booking}

// //                 onViewDetails={handleViewDetails}

// //                 onWriteReview={handleWriteReview}

// //               />

// //             ))}

// //           </div>

// //           {/* Empty state when no bookings */}

// //           {filteredBookings.length === 0 && (

// //             <div className="text-center py-12 sm:py-16">

// //               <p className="text-gray-500 text-sm sm:text-base">

// //                 No bookings found in this category

// //               </p>

// //             </div>

// //           )}

// //         </div>

// //       </div>

// //       {/* Modals */}

// //       {showDetailsModal && (

// //         <BookingDetailsModal

// //           booking={selectedBooking}

// //           onClose={handleCloseModals}

// //         />

// //       )}

// //       {showReviewModal && (

// //         <ReviewModal

// //           booking={selectedBooking}

// //           onClose={handleCloseModals}

// //           onSubmit={handleSubmitReview}

// //         />

// //       )}

// //     </div>

// //   );

// // };

// // export default MyBooking;

// import React, { useState, useEffect } from "react";
// import BookingCard from "src/components/Booking/BookingCard";
// import BookingDetailsModal from "src/components/Booking/BookingDetailsModal";
// import ReviewModal from "src/components/Booking/ReviewModal";
// import { getProposals } from "../api/proposal";
// import { mapProposalToBooking } from "../utils/bookingUtils";
// import { LayoutGrid, List, Heart, Bell, MessageSquare } from "lucide-react";

// const MyBooking = () => {
//   const tabs = ["Event", "Package", "Cancelled"];
//   const [activeTab, setActiveTab] = useState("Event");
//   const [subType, setSubType] = useState("Events");

//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [showDetailsModal, setShowDetailsModal] = useState(false);
//   const [showReviewModal, setShowReviewModal] = useState(false);

//   const [bookedEvents, setBookedEvents] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchBookings = async () => {
//       setLoading(true);
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) return;

//         const proposals = await getProposals(token);

//         const filtered = proposals
//           .filter(p => {
//             if (activeTab === "Event") return p.status === 'accepted';
//             if (activeTab === "Cancelled") return p.status === 'cancelled';
//             return true;
//           })
//           .map(p => mapProposalToBooking(p));

//         setBookedEvents(filtered);
//       } catch (error) {
//         console.error("Failed to fetch booked events:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBookings();
//   }, [activeTab]);

//   const handleViewDetails = (booking) => {
//     setSelectedBooking(booking);
//     setShowDetailsModal(true);
//   };

//   const handleWriteReview = (booking) => {
//     setSelectedBooking(booking);
//     setShowReviewModal(true);
//   };

//   const handleCloseModals = () => {
//     setShowDetailsModal(false);
//     setShowReviewModal(false);
//     setTimeout(() => setSelectedBooking(null), 300);
//   };

//   const handleSubmitReview = (reviewData) => {
//     console.log("Review submitted:", reviewData);
//     alert("Thank you for your review!");
//     handleCloseModals();
//   };

//   return (
//     <div className="min-h-screen bg-white font-sans">
//       {/* --- Header --- */}
//       <nav className="bg-white border-b border-gray-100 px-6 py-3 flex items-center justify-between">
//         <div className="flex items-center gap-2">
//           <div className="bg-[#FF5722] p-1.5 rounded-md">
//             <span className="text-white font-bold text-xl">G</span>
//           </div>
//           <span className="text-[#333] font-bold text-lg">GoPratle</span>
//         </div>

//         <div className="flex items-center gap-6">
//           <div className="flex gap-4 text-gray-600">
//             <div className="relative cursor-pointer">
//                <MessageSquare size={20} />
//                <span className="absolute -top-1 -right-1 bg-[#FF5722] text-white text-[10px] rounded-full w-3.5 h-3.5 flex items-center justify-center">1</span>
//             </div>
//             <div className="relative cursor-pointer">
//                <Bell size={20} />
//                <span className="absolute -top-1 -right-1 bg-[#FF5722] text-white text-[10px] rounded-full w-3.5 h-3.5 flex items-center justify-center">1</span>
//             </div>
//             <Heart size={20} className="cursor-pointer" />
//           </div>
//           <button className="bg-[#FF5722] text-white px-5 py-2 rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors">
//             Plan my Event
//           </button>
//           <div className="w-9 h-9 bg-[#FFE0D3] text-[#FF5722] rounded-full flex items-center justify-center font-semibold border border-orange-100">
//             H
//           </div>
//         </div>
//       </nav>

//       {/* --- Main Content --- */}
//       <div className="max-w-7xl mx-auto px-8 py-8">
//         <h1 className="text-3xl font-bold text-gray-900 mb-8">My Booking</h1>

//         {/* Tabs & Global Controls Row */}
//         <div className="flex items-center justify-between border-b border-gray-100 mb-8">
//           {/* Main Tabs */}
//           <div className="flex gap-12">
//             {tabs.map((tab) => (
//               <button
//                 key={tab}
//                 onClick={() => setActiveTab(tab)}
//                 className={`pb-4 text-xl font-medium transition-all relative ${
//                   activeTab === tab
//                     ? "text-[#FF5722]"
//                     : "text-gray-400 hover:text-gray-600"
//                 }`}
//               >
//                 {tab}
//                 {activeTab === tab && (
//                   <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#FF5722] rounded-full" />
//                 )}
//               </button>
//             ))}
//           </div>

//           {/* Right side controls (Always visible Sort & View + Conditional Toggle) */}
//           <div className="flex items-center gap-4 pb-2">

//             {/* Events/Packages Toggle (Sirf Cancelled tab par dikhega) */}
//             {activeTab === "Cancelled" && (
//               <div className="flex items-center border border-gray-200 rounded-md overflow-hidden h-9 animate-in fade-in duration-300">
//                 <button
//                   onClick={() => setSubType("Events")}
//                   className={`px-4 text-xs font-medium h-full transition-colors ${subType === "Events" ? "bg-white text-[#FF5722] border-[#FF5722] border" : "bg-gray-50 text-gray-400"}`}
//                 >
//                   Events
//                 </button>
//                 <button
//                   onClick={() => setSubType("Packages")}
//                   className={`px-4 text-xs font-medium h-full transition-colors ${subType === "Packages" ? "bg-white text-[#FF5722] border-[#FF5722] border" : "bg-gray-50 text-gray-400"}`}
//                 >
//                   Packages
//                 </button>
//               </div>
//             )}

//             {/* Sort Dropdown (Visible on all tabs) */}
//             <div className="flex items-center border border-gray-200 rounded-md px-3 py-1.5 h-9 bg-white">
//               <span className="text-sm text-gray-500 mr-2">Sort by</span>
//               <select className="text-sm font-medium bg-transparent outline-none cursor-pointer">
//                 <option>Newest</option>
//                 <option>Oldest</option>
//               </select>
//             </div>

//             {/* Grid/List View (Visible on all tabs) */}
//             <div className="flex border border-gray-200 rounded-md overflow-hidden h-9">
//               <button className="px-2 bg-white text-gray-400 border-r border-gray-200">
//                 <List size={18} />
//               </button>
//               <button className="px-2 bg-white text-[#FF5722]">
//                 <LayoutGrid size={18} />
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* --- Grid Layout --- */}
//         {loading ? (
//           <div className="flex justify-center py-20">
//             <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#FF5722]"></div>
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
//             {bookedEvents.map((booking) => (
//               <BookingCard
//                 key={booking.id}
//                 booking={booking}
//                 onViewDetails={handleViewDetails}
//                 onWriteReview={handleWriteReview}
//               />
//             ))}
//           </div>
//         )}

//         {!loading && bookedEvents.length === 0 && (
//           <div className="text-center py-24">
//             <p className="text-gray-400 font-medium">No {activeTab} records found</p>
//           </div>
//         )}
//       </div>

//       {/* --- Modals --- */}
//       {showDetailsModal && (
//         <BookingDetailsModal
//           booking={selectedBooking}
//           onClose={handleCloseModals}
//         />
//       )}

//       {showReviewModal && (
//         <ReviewModal
//           booking={selectedBooking}
//           onClose={handleCloseModals}
//           onSubmit={handleSubmitReview}
//         />
//       )}
//     </div>
//   );
// };

// export default MyBooking;

import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { getBookedEvents } from "../api/event";
import BookingEventCard from "../components/Booking/BookingEventCard";

const MyBooking = () => {
  const tabs = ["Event", "Cancelled"];
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [sortBy, setSortBy] = useState("latest");
  const [fetchedEvents, setFetchedEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  const sortDropdownRef = useRef(null);

  const sortOptions = [
    { id: "latest", label: "Latest Booked" },
    { id: "oldest", label: "Oldest Booked" },
  ];



  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        sortDropdownRef.current &&
        !sortDropdownRef.current.contains(event.target)
      ) {
        setShowSortDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  // Fetch bookings whenever activeTab changes
  useEffect(() => {
    const fetchBookings = async () => {
      setLoading(true);
      try {
        const type = activeTab === "Event" ? "booked" : "cancelled";
        const events = await getBookedEvents({ type });
        setFetchedEvents(events);
      } catch (error) {
        console.error("Failed to fetch bookings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, [activeTab]);

  const allFilteredEvents = useMemo(() => {
    const list = [...fetchedEvents];

    const parseBookedDate = (event) => {
      const value =
        event.bookedAt ||
        event.bookingDate ||
        event.updatedAt ||
        event.createdAt ||
        event.startDate ||
        "";
      const timestamp = new Date(value).getTime();
      return Number.isNaN(timestamp) ? 0 : timestamp;
    };

    if (sortBy === "oldest") {
      list.sort((a, b) => parseBookedDate(a) - parseBookedDate(b));
    } else {
      list.sort((a, b) => parseBookedDate(b) - parseBookedDate(a));
    }

    return list;
  }, [fetchedEvents, sortBy]);

  const handleSortDropdownToggle = (e) => {
    e.stopPropagation();
    setShowSortDropdown((prev) => !prev);
  };

  const handleSortSelection = (sortId, e) => {
    e.stopPropagation();
    setSortBy(sortId);
    setShowSortDropdown(false);
  };

  return (
    <div className="my-booking-page min-h-screen bg-white pt-20 sm:pt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 relative">
        <h1 className="text-2xl font-semibold mb-6 text-black">My Booking</h1>

        <div className="mb-4 sm:mb-5 overflow-x-auto border-b border-gray-100">
          <div className="flex gap-5 sm:gap-7 min-w-max">
            {tabs.map((tab) => (
              <button
                type="button"
                key={tab}
                className={`pb-3 text-sm sm:text-base whitespace-nowrap transition-all ${
                  activeTab === tab
                    ? "border-b-2 border-orange-500 font-medium text-black"
                    : "text-gray-500 hover:text-gray-700"
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div
          className="relative z-30 flex items-center justify-end gap-3 mb-6"
          ref={sortDropdownRef}
        >
          <div className="relative">
            <button
              type="button"
              onClick={handleSortDropdownToggle}
              className="flex items-center gap-2 border border-gray-200 px-4 py-2 rounded-lg text-sm text-gray-600 bg-white"
            >
              Sort by
              <ChevronDown size={16} />
            </button>

            {showSortDropdown && (
              <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 shadow-lg rounded-lg z-50 opacity-100">
                {sortOptions.map((option) => (
                  <button
                    type="button"
                    key={option.id}
                    onClick={(e) => handleSortSelection(option.id, e)}
                    className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-50 ${
                      sortBy === option.id
                        ? "text-[#FF4C18] font-medium"
                        : "text-gray-700"
                    }`}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {loading ? (
          <div className="text-center py-14 text-gray-500">
            Loading bookings...
          </div>
        ) : allFilteredEvents.length > 0 ? (
          <div className="relative z-0 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2.5 sm:gap-5 lg:gap-6">
            {allFilteredEvents.map((event) => (
              <div key={event._id} className="relative z-0">
                <BookingEventCard event={event} isCancelled={activeTab === "Cancelled"} />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 sm:py-16">
            <p className="text-gray-500 text-sm sm:text-base">
              No bookings found in this category
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyBooking;
